<template>
  <div class="product">
    <!--导航栏-->
    <header-nav></header-nav>

    <div class="container">
      <div class="filter-box noSelect">
        <div class="filter-item">
          <span class="filter-key">分类筛选：</span>
          <div class="filter-val-list">
            <div v-for="(item, index) in copyright"
                 :key="index"
                 class="filter-val-item"
                 :class="{active: index === activeIndex}"
                 @click="onSelectCity(index, item.id)">{{item.category_name}}
            </div>
          </div>
        </div>
        <div class="filter-item">
          <span class="filter-key">平&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;台：</span>
          <div class="filter-val-list">
            <div v-for="(item, index) in source_list"
                 :key="index"
                 class="filter-val-item"
                 :class="{active: index === source}"
                 @click="onSelectSource(index, item)">
              <img class="icon" :src="IMG_URL+'images/order/'+item.icon" alt="">
              {{item.name}}
            </div>
          </div>
        </div>
        <div class="filter-item">
          <span class="filter-key">快&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;递：</span>
          <div class="filter-val-list">

            <!-- <div class="filter-val-item"
                :class = "{active: 0 === express_index}"
                 @click="onSelectQuanBu()"
                 >
              全部快递
            </div> -->

            <div v-for="(item, index) in tableExpressData"
                 :key="index"
                 class="filter-val-item"
                 :class="{active: index === express_index}"
                 @click="onSelectDelivery(index, item)">
              {{item.delivery_name}}
            </div>
          </div>
        </div>
        <div class="filter-item">
          <span class="filter-key">仓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;储：</span>
          <div class="filter-val-list">
            <div class="filter-val-item"
                 v-for="(item, index) in depotList"
                 :key="index"
                 :class="{active: index === kdIndex}"
                 @click="onSelectKd(index, item)">
              <!--              <img v-if="index > 0" class="icon" :src="iconFilter(item.depot_name)" alt="">-->

              {{ item.city ? item.city + item.delivery_name : item.address }}{{item.depot_name | typeFilter}}

              <i class="item" v-if="item.sort>1000">
                热门推荐
              </i>
            </div>
          </div>
        </div>
      </div>

      <!--商品列表-->
      <div class="gift-list clearfix"
           v-if="tableData.length > 0"
           v-loading="loadingGift"
           element-loading-text="礼品加载中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(255, 255, 255, 0.8)"
           :default-sort = "{prop: 'date', order: 'descending'}">
        <gift-item v-for="item in tableData" :key="item.id" :path="'product'" :source="source" :item="item"></gift-item>
      </div>
      <div class="no-data" v-else>
        <img :src="`${IMG_URL}images/no_product.png`" alt="">
      </div>
      <div class="page-box">
        <el-pagination
            v-if="tableData.length > 0"
            :page-size="param.limit"
            :total="totalCount"
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"/>
      </div>
    </div>

    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index"
import giftItem from "@/components/giftItem/index"
import footerBox from "@/components/footerBox/index"
import {apiProductList, apiDepotGet, apiExpressGet, apiIndexGet, apiOrderGetPrice} from '@/api/api'

export default {
  name: "product",
  components: {headerNav, giftItem, footerBox},
  filters: {
    depotFilter(val) {
      var depot = ''
      if (val) {
        if (val.indexOf('淘宝') !== -1) {
          depot = '-淘宝'
        } else if (val.indexOf('拼多多') !== -1) {
          depot = '-拼多多'
        } else if (val.indexOf('京东') !== -1) {
          depot = '-京东'
        } else if (val.indexOf('快手') !== -1) {
          depot = '-快手'
        } else if (val.indexOf('抖音') !== -1) {
          depot = '-抖音'
        }
      }
      return depot
    },
    typeFilter(val){
      var type = "";
      if (val.indexOf('自提') !== -1) {
        type = '-自提'
      } else if (val.indexOf('部分自提') !== -1) {
        type = '-部分自提'
      }
      return type;
    }
  },
  data() {
    return {
      loadingGift: true,
      source: 0,
      source_id: 0,
      source_list: [
        {name: '淘宝/天猫', source_id: 0, icon: 'tb-icon.png', platform: 'TbAcs'},
        {name: '京东', source_id: 1, icon: 'jd-icon.png', platform: 'JdAcs'},
        {name: '拼多多', source_id: 2, icon: 'pdd-icon.png', platform: 'PddAcs'},
        {name: '抖音', source_id: 4, icon: 'dy-icon.png', platform: 'DyAcs'},
        {name: '快手', source_id: 5, icon: 'ks-icon.png', platform: 'KsAcs'},
      ],
      sort_list: [{name: '默认排序', sort: ''}, {name: '价格最低', sort: 'price_asc'}, {
        name: '销量最高',
        sort: 'sales_desc'
      }, {name: '重量最重', sort: 'weight_desc'}, {name: '最新发布', sort: 'time_desc'}],
      activeIndex: 0,
      sortIndex: 0,
      express_index: 0,
      kdIndex: 0,
      loading: true,
      totalCount: 0,
      delivery_code: '',
      param: {
        product_id: '',
        page: 1,
        total: 0,
        depot_id: '',
        category_id: '',
        keyword: "",
        limit: 20,
        sort: ''
      },
      tableData: [],
      depotList: [],
      tableExpressData: [],
      totalExpressCount: [],
      copyright: [{category_name: '全部分类', id: 0}]
    }
  },
  mounted() {
    this.IndexLstGet()
    this.apiExpressGet()
    setTimeout(() => {
      this.loading = false
    }, 2000)
  },
  methods: {
    IndexLstGet() {
      apiIndexGet().then(res => {
        if (res.code === 1) {
          if(res.data.copyright_lst){
            this.copyright = this.copyright.concat(res.data.copyright_lst)
          }else if(res.data.copyright){
            this.copyright = this.copyright.concat(res.data.copyright)
          }
        }
      })
    },
    handleCurrentChange(val) {
      this.param.page = val
      this.loadData()
    },
    //筛选平台
    onSelectSource(index, row) {
      if(index === this.source) return;
      this.source = index;
      this.source_id = row.source_id;
      this.loadDepotGet();
    },
    // 筛选分类
    onSelectCity(index, id) {
      if(index === this.activeIndex) return;
      this.activeIndex = index
      this.param.category_id = id
      this.loadDepotGet()
      this.loadData()
    },
    //筛选快递
    onSelectDelivery(index) {
      if(index === this.express_index) return;
      this.express_index = index;
      this.delivery_code = this.tableExpressData[index].delivery_name;
      this.kdIndex = 0;
      this.param.depot_id = '';
      this.loadDepotGet()
    },
    // 全部快递
    onSelectQuanBu(){
      this.param.depot_id='';
      this.loadData();
    },
    // 筛选仓库
    onSelectKd(index, item) {
      if(index === this.kdIndex) return;
      this.kdIndex = index;
      this.param.depot_id = item.depot_id;
      this.loadData()
    },
    //获取快递列表
    apiExpressGet() {
      apiExpressGet({}).then(res => {
        // var express_list = [{delivery_name: '全部快递', delivery_code: ''}];
        var express_list = {delivery_name: '全部快递', delivery_code: ''};
        this.tableExpressData = res.data.rows;
        this.tableExpressData.unshift(express_list)
        this.totalExpressCount = res.data.total;
        this.delivery_code = res.data.rows[0].delivery_name;
        this.loadDepotGet();
      })
    },
    //获取仓库列表
    loadDepotGet() {
      apiOrderGetPrice({
        express_name: this.delivery_code,
        category_id: this.param.category_id,
        source: this.source_id
      }).then(res => {
        this.depotList = res.data;
        if(res.data.length > 0){
          this.param.depot_id = res.data[0].depot_id;
        }else{
          this.param.depot_id = 0;
        }
        this.loadData()
      })
    },
    //获取商品列表
    loadData() {
      this.loadingGift = true;
      const param = this.param
      if (param.category_id == 0) {
        delete param.category_id
      }
      apiProductList(this.param).then(res => {
        this.totalCount = res.data.total
        this.tableData = res.data.rows;
        this.loadingGift = false;
      })
    }
  }
}
</script>

<style scoped lang="scss">
.product {
  min-width: 1300px;
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  background-color: #eeeeee;

  .filter-box {
    background-color: #ffffff;
    padding: 0 30px;

    .filter-item {
      padding: 15px 0;
      border-bottom: 1px solid #E6E6E6;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:last-child {
        border: none;
      }

      .filter-key {
        color: #878787;
        margin-right: 10px;
      }

      .filter-val-list {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        .filter-val-item {
          font-size: 14px;
          margin-right: 20px;
          height: 35px;
          padding: 0 10px;
          cursor: pointer;
          display: flex;
          align-items: center;
          position: relative;

          .item{
            background: #f05555;
            border-color: #f05555;
            display: block;
            padding: 0 6px;
            font-size: 12px;
            white-space: nowrap;
            height: 18px;
            color: #fff;
            line-height: 18px;
            border-radius: 4px;
            position: absolute;
            top: -25px;
            left: 80%;
            font-style: normal;
            animation: tag1 2s linear infinite;
            -webkit-animation: tag1 2s linear infinite;
          }

          @keyframes tag1 {
            0%{
              transform: translateY(0);
            }
            50% {
                transform: translateY(-5px);
            }
            100% {
                transform: translateY(0);
            }
          }

          .item::after {
            content: '';
            display: block;
            border: 4px solid transparent;
            border-style:solid;
            border-top-color: inherit;
            position: absolute;
            top: 100%;
            left: 4px;
          }
          .icon {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            margin-right: 5px;
          }

          &.active {
            color: #0f375a;
            font-weight: bold;
            border:  #1a2ea3 1px solid;
          }

          &:hover {
            color: #0f375a;
            font-weight: bold;
          }
        }
      }
    }
  }

  .gift-list {
    margin: 20px 0 0;
  }
  .gift-list > div:nth-child(4n+0){
    margin: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/product/index.vue